import {Component} from 'react';

export default class UnionTableList extends Component {
  componentDidMount() {
    // this.customize = localStorage.getItem('customize') || '';
    this.freshTableList();
  }

  // 第一次刷新拉取table列表数据
  freshTableList = () => {
    const {
      getTableList,
      pageStatus: {pageNum = 1, pageSize = 20},
      searchData,
    } = this.props;

    getTableList({
      ...searchData,
      pageNum,
      pageSize,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const {current, pageSize} = pagination;
    const {getTableList, searchData} = this.props;
    let sortFlag;
    const sorterLength = Object.keys(sorter).length;

    if (sorterLength && sorter.columnKey === 'lastModifyTime') {
      sortFlag = sorter.order === 'descend' ? 0 : 1;
    }

    this.setPageStatus({pageNum: current, pageSize});
    getTableList({
      ...searchData,
      pageNum: current,
      pageSize,
      sortFlag,
    });
  };

  setPageStatus = values => {
    const {actions} = this.props;

    actions.setPageStatus({...values});
  };
}
